export const TIMEINTERVAL = 120000; // 2 minutes in milliseconds (2 minutes * 60,000)
export const POLLINGINTERVAL = 20000;
export const PAGESIZE = 8;

// Standardized responsive breakpoints (Ant Design standard)
export const BREAKPOINTS = {
    xs: 576,   // Mobile
    sm: 576,   // Large mobile
    md: 1080,   // Tablet
    lg: 1080,   // Desktop
    xl: 1200,  // Large desktop
    xxl: 1600  // Extra large
} as const;

// Touch target minimum size for mobile accessibility
export const TOUCH_TARGET_MIN_SIZE = 44; // 44x44px minimum for mobile

// Fuel level thresholds (percentage)
export const FUEL_CRITICAL = 20;  // 0-20: Critical
export const FUEL_LOW = 50;       // 21-50: Low
export const FUEL_MODERATE = 80;  // 51-80: Moderate
export const FUEL_GOOD = 100;     // 81-100: Good

// Legacy thresholds (kept for backward compatibility)
export const ONEQUATER = 25;
export const HALF = 50;
export const REFUELED = 90;
export const THREEQUATER = 75;
export const FULL = 100;
export const INTRODUCTION = "Introduction";
export const GENERAL = "General";
export const MAINTENANCE = "maintenance";
export const UPCOMING_MAINTENANCE = "upcomingmaintenance";
export const GLOBAL_REPORTS = "GlobalReports";
export const CHARGERS = "Chargers";
export const POWER_GENERATION = "Power";
export const POWER_DIAG = "PowerDiag";
export const FUEL = "Fuel";
export const SOLAR = "Solar";
export const STARLINK = "Starlink";

export const REPORTS = "Reports";
export const CAMERAS = "Cameras";
export const ALARMS = "Alarms";
export const HELP = "Help";
export const MAPS = "Maps";
export const COMMUNICATION = "Communication"
export const GLOBAL_MAPS = "globalmaps"
export const DASHBOARD = "Dashboard";
export const MANUALS = "manuals";
export const FACTORY_DASHBOARD = "FactoryDashboard";
export const EXECUTIVE_DASHBOARD = "ExecutiveDashboard";
export const EXECUTIVE_DASHBOARD_LABEL = "EXECUTIVE VIEW";
export const REMOTE = "remote";
export const EVENTS = "Events";
export const LOGS = 'Logs';
export const GLOBAL_LOGS = 'globalLogs';
export const SUPPORT = "support";
export const DOCUMENTATION = "documentation";
export const CONTROL_PANEL = "ControlPanel";

//Calling initial zoom level of the map when it loads.
export const MAP_ZOOM_LEVEL = 16

// Setting timezones in Power Generation Tabs and fuelchart
const TIMEZONES: { value: string, label: string }[] = [
    { value: "UTC", label: "UTC" },
    { value: "America/Chicago", label: "US/Central" },
    { value: "America/New_York", label: "US/Eastern" },
    { value: "America/Denver", label: "US/Mountain" },
    { value: "America/Los_Angeles", label: "US/Pacific" }
];

// Setting headers for downloaded csv
const HEADERS = [
    { label: "Datetime", key: "value_datetime" },
    { label: "Value", key: "value" },
    { label: "Value Name", key: "value_name" },
    { label: "Generator Name", key: "generator_name" },
];

export { TIMEZONES, HEADERS };

export const CHARGER_DATA_POLLING_INTERVAL = 60000; // 30 seconds in milliseconds (30 seconds * 1,000)

export const GREEN = 2

export const RED = 0

export const ORANGE = 1;

export const NEW_CHARGER_POLLING_RATE = 60000;

export const grey = "#808080";
export const red = "#FF432C";
export const green = "#38B34A";
export const yellow = "#FDA400"
export const blue = "#0586FF";
export const orange = "#F19D00";

// Fuel level colors
export const FUEL_COLOR_CRITICAL = "#E53935";  // Red - rgb(229,57,53)
export const FUEL_COLOR_LOW = "#FB8C00";       // Orange - rgb(251,140,0)
export const FUEL_COLOR_MODERATE = "#FDD835";  // Yellow - rgb(253,216,53)
export const FUEL_COLOR_GOOD = "#43A047";      // Green - rgb(67,160,71)

export const faults = [
    'Emergency Stop',
    'High Engine Temp',
    'Low Coolant Level',
    'Low Coolant Temp',
    'Oil Pressure Low',
    'Overcrank',
    'Overspeed',
    'Shutdown Alarm',
];

export const alarms = ['Battery Charge Alarm', 'Common Alarm', 'Warning Alarm'];

export function getBatteryStatusColor(voltage: number | 'N/A', isLive: boolean) {
    if (voltage === 'N/A' || !isLive || voltage < 0) return { status: 'Unknown/Offline', fillColor: grey };
    if (voltage === 0) return { status: 'No Voltage', fillColor: grey };
    if (voltage < 10) return { status: 'Low', fillColor: red };
    if (voltage < 12) return { status: 'Moderate', fillColor: orange };
    return { status: 'Good', fillColor: green };
}

// Re-export geojson-based region detection functions
// These use point-in-polygon testing with actual geojson boundaries for accuracy
// Note: Call preloadGeojsonData() during app initialization for these to work
export { getUSRegionFromCoordinates, getCARegionFromCoordinates, getCountryFromCoordinates } from './geojsonUtils';
